module.exports = __webpack_public_path__ + "img/gate-rail-vertical-shadow.1471c9b0.png";